import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof8: FaireReviewEntity = {
  token: "review_sof8",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_2r2z8pkpkf",
  reviewerName: "Sheila",
  reviewerLocation: "Hudson Falls, NY",
  stars: 5,
  reviewText: "Softies quality is amazing, and is so wonderful to find a brand that is so size inclusive! My customers absolutely loved the dream lounge sets, robes & socks!! A huge success for my first Holiday season in business.",
  reviewDate: "Feb 21, 2025",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
